import { Box } from '@mui/material';
import { styled, SxProps } from '@mui/material/styles';
import React, { CSSProperties } from 'react';

const StyColoredChipWrapper = styled(Box, {
    name: 'StyColoredChipWrapper',
    shouldForwardProp: (prop) => !['backgroundColor', 'color'].includes(prop),
})<{
    backgroundColor: CSSProperties['backgroundColor'];
    color: CSSProperties['color'];
}>(({ backgroundColor, color }) => ({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    height: 'max-content',
    width: 'max-content',
    borderRadius: '20px',
    padding: '0.4rem 0.8rem',
    marginRight: '1rem',
    backgroundColor,
    border: `1px solid ${color}`,
    color,
}));

type Props = {
    color: CSSProperties['color'];
    backgroundColor: CSSProperties['backgroundColor'];
    content: string;
    className?: string;
    sx?: SxProps;
};

export default function ColoredChip({
    color,
    backgroundColor,
    content,
    className = undefined,
    sx = undefined,
}: Props): React.ReactElement {
    return (
        <StyColoredChipWrapper
            color={color}
            backgroundColor={backgroundColor}
            className={className}
            sx={sx}
        >
            {content}
        </StyColoredChipWrapper>
    );
}
